module.exports = __webpack_public_path__ + "img/SN.4775a47e.svg";